import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import env from "../../config/env.js";
import AcessoRestrito from '../../components/AcessoRestrito';
import { useSystemMessagesContext } from "../../contexts/SystemMessagesContext";
import { verificarAcessoUsuario } from "../../utils/authStandards";
import * as MuiIcons from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormControlLabel,
  Switch,
  Tooltip,
  TableSortLabel,
  CircularProgress,
  Alert,
  Snackbar,
  Tabs,
  Tab,
  TablePagination,
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Print as PrintIcon,
  Business as BusinessIcon,
  Close as CloseIcon
} from "@mui/icons-material";
import ThumbUp from "@mui/icons-material/ThumbUp";
import ThumbDown from "@mui/icons-material/ThumbDown";

import api from "../../services/api";
import { formatarTelefone } from "../../utils/formatadores";


// Arrays estáticos de status e tipos
const STATUS_OPTIONS = [
  { value: "Ativo", label: "Ativo" },
  { value: "Inativo", label: "Inativo" }
];

const TIPO_PESSOA_OPTIONS = [
  { value: "FISICA", label: "Física" },
  { value: "JURIDICA", label: "Jurídica" }
];

export default function Empresas() {
  const location = useLocation();
  
  const [order, setOrder] = useState("asc");
  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
  const [empresaVisualizar, setEmpresaVisualizar] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [empresaParaExcluir, setEmpresaParaExcluir] = useState(null);
  const [moduleInfo, setModuleInfo] = useState(null);
  const [formData, setFormData] = useState({
    st_nome: "",
    st_tipoPessoa: TIPO_PESSOA_OPTIONS[1].value,
    st_cpfCnpj: "",
    st_email: "",
    st_telefone: "",
    st_endereco: "",
    st_observacoes: "",
    bo_ativo: true,
  });

  // Estados adicionais que estavam faltando
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [filtros, setFiltros] = useState({
    st_nome: "",
    st_email: "",
    st_cpfCnpj: "",
    st_tipoPessoa: "",
    bo_ativo: ""
  });
  const [orderBy, setOrderBy] = useState("st_nome");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [formErrors, setFormErrors] = useState({
    st_nome: false,
    st_cpfCnpj: false,
    st_email: false,
    st_telefone: false
  });
  const [dataHoraAtual, setDataHoraAtual] = useState(new Date());

  const st_codHashEmpresaOrigem = localStorage.getItem("st_codHashEmpresa");
  const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
  const st_codHashEmpresaLocal = (usuarioLogado && usuarioLogado.st_codHashEmpresa);

  const carregarEmpresas = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Token não encontrado");
        window.location.href = "/login";
        return;
      }

      const res = await api.get(`/empresas?st_codHashEmpresa=${st_codHashEmpresaLocal}`);

      let lista = res.data;

      if ((usuarioLogado && usuarioLogado.perfil) !== "superusuario") {
        lista = lista.filter(empresa => 
            empresa.st_codHashEmpresa === st_codHashEmpresaLocal ||
            empresa.st_codHashOrigem === st_codHashEmpresaLocal
        );
      }

      setEmpresas(lista);
    } catch (error) {
      console.error('Erro ao carregar empresas:', error);
      setError('Erro ao carregar empresas');
    } finally {
      setLoading(false);
    }
  };

  // Função para obter ícone do Material-UI por nome
  const getMuiIconByName = (iconName) => {
    const IconComponent = MuiIcons[iconName];
    if (!IconComponent) {
      console.warn(`Ícone "${iconName}" não encontrado`);
      return MuiIcons['Help']; // Ícone padrão
    }
    return IconComponent;
  };

  // Carregar informações do módulo
  useEffect(() => {
    const carregarInfoModulo = () => {
      try {
        const modulos = JSON.parse(localStorage.getItem('modulos') || '[]');
        const moduloAtual = modulos.find(mod => mod.path === location.pathname);
        
        if (moduloAtual) {
          setModuleInfo(moduloAtual);
        } else {
          // Fallback para informações padrão do módulo
          setModuleInfo({
            nome: 'Empresas',
            icone: 'empresas',
            path: '/empresas'
          });
        }
      } catch (error) {
        console.warn('Erro ao carregar informações do módulo:', error);
        // Fallback para informações padrão
        setModuleInfo({
          nome: 'Empresas',
          icone: 'empresas',
          path: '/empresas'
        });
      }
    };

    carregarInfoModulo();
  }, [location.pathname]);

  // Funções para confirmação de exclusão
  const confirmarExclusao = (empresa) => {
    setEmpresaParaExcluir(empresa);
    setOpenDeleteConfirm(true);
  };

  const fecharConfirmacaoExclusao = () => {
    setOpenDeleteConfirm(false);
    setEmpresaParaExcluir(null);
  };

  useEffect(() => {
    carregarEmpresas();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setDataHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatarDataHora = (data) => {
    return data.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    let valorFormatado = value;

    // Aplica a formatação apropriada
    if (name === 'st_cpfCnpj') {
      if (formData.st_tipoPessoa === TIPO_PESSOA_OPTIONS[0].value) {
        valorFormatado = formatarCPF(value);
      } else {
        valorFormatado = value.replace(/\D/g, '').replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
      }
    } else if (name === 'st_telefone') {
      valorFormatado = formatarTelefone(value);
    }

    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : valorFormatado
    }));

    // Limpa o erro do campo quando ele é alterado
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const abrirFormulario = (empresa = null) => {
    setEmpresaSelecionada(empresa);
    if (empresa) {
      setFormData({
        st_nome: empresa.st_nome || "",
        st_tipoPessoa: empresa.st_tipoPessoa || TIPO_PESSOA_OPTIONS[1].value,
        st_cpfCnpj: empresa.st_cpfCnpj || "",
        st_email: empresa.st_email || "",
        st_telefone: empresa.st_telefone || "",
        st_endereco: empresa.st_endereco || "",
        st_observacoes: empresa.st_observacoes || empresa.st_observacao || "",
        bo_ativo: empresa.bo_ativo !== undefined ? empresa.bo_ativo : true,
      });
    } else {
      setFormData({
        st_nome: "",
        st_tipoPessoa: TIPO_PESSOA_OPTIONS[1].value,
        st_cpfCnpj: "",
        st_email: "",
        st_telefone: "",
        st_endereco: "",
        st_observacoes: "",
        bo_ativo: true,
      });
    }
    setActiveTab(0);
    setOpenForm(true);
  };

  const visualizarEmpresa = (empresa) => {
    setEmpresaVisualizar(empresa);
    setActiveTab(0);
    setOpenView(true);
  };

  const fecharFormulario = () => {
    setOpenForm(false);
    setEmpresaSelecionada(null);
  };

  const fecharVisualizacao = () => {
    setOpenView(false);
    setEmpresaVisualizar(null);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const validarFormulario = () => {
    const novosErros = {
      st_nome: !formData.st_nome,
      st_cpfCnpj: !formData.st_cpfCnpj,
      st_email: !formData.st_email,
      st_telefone: !formData.st_telefone
    };

    setFormErrors(novosErros);
    return !Object.values(novosErros).some(erro => erro);
  };

  const gerarHashEmpresa = () => {
    const cryptoObj = window.crypto || window.msCrypto;

    if (cryptoObj?.getRandomValues) {
      const bytes = new Uint8Array(32); // 32 bytes => 64 caracteres hexadecimais
      cryptoObj.getRandomValues(bytes);
      return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("").toUpperCase();
    }

    // Fallback em caso de ambientes sem Web Crypto
    const fallback = Math.random().toString(16).slice(2) + Date.now().toString(16);
    return fallback.padEnd(64, "0").slice(0, 64).toUpperCase();
  };

  const salvarEmpresa = async () => {
    if (!validarFormulario()) {
      setError("Por favor, preencha todos os campos obrigatórios");
      return;
    }

    try {
      setLoading(true);
      
      // Processar observações antes de criar dadosFormatados
      const observacoesProcessadas = formData.st_observacoes 
        ? (typeof formData.st_observacoes === 'string' ? formData.st_observacoes.trim() : formData.st_observacoes)
        : null;

      const dadosFormatados = {
        ...formData,
        st_cpfCnpj: formData.st_cpfCnpj.replace(/\D/g, ""),
        st_telefone: formData.st_telefone.replace(/\D/g, ""),
        st_codHashOrigem: st_codHashEmpresaOrigem || null,
        st_codHashEmpresa: empresaSelecionada ? empresaSelecionada.st_codHashEmpresa : gerarHashEmpresa(),
        // Sempre incluir observações explicitamente
        st_observacoes: observacoesProcessadas || null
      };

      // Limpar campos vazios (exceto observações que já foi tratado)
      Object.keys(dadosFormatados).forEach(key => {
        if (key !== 'st_observacoes' && (dadosFormatados[key] === "" || dadosFormatados[key] === undefined)) {
          dadosFormatados[key] = null;
        }
      });

      if (empresaSelecionada) {
        // Atualização (PUT)
        const empresaId = empresaSelecionada.id || empresaSelecionada.id_empresa;
        if (!empresaId) {
          setError("ID da empresa não encontrado");
          return;
        }
        await api.put(`/empresas/${empresaId}?st_codHashEmpresa=${st_codHashEmpresaOrigem}`, dadosFormatados);
        setSuccess("Empresa atualizada com sucesso!");
      } else {
        // Criação (POST)
        await api.post('/empresas', dadosFormatados);
        setSuccess("Empresa criada com sucesso!");
      }

      setOpenForm(false);
      carregarEmpresas();
    } catch (error) {
      if (error.response?.status === 401) {
        setError("Sessão expirada. Por favor, faça login novamente.");
      } else {
        setError(error.response?.data?.message || "Erro ao salvar empresa");
      }
    } finally {
      setLoading(false);
    }
  };

  const deletarEmpresa = async () => {
    if (!empresaParaExcluir) return;

    try {
      setLoading(true);
      
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      const empresaId = empresaParaExcluir.id || empresaParaExcluir.id_empresa;
      if (!empresaId) {
        setError("ID da empresa não encontrado");
        return;
      }
      await api.delete(`/empresas/${empresaId}?st_codHashEmpresa=${codHashEmpresa}`);
      
      setSuccess("Empresa excluída com sucesso!");
      carregarEmpresas();
    } catch (error) {
      if (error.response?.status === 401) {
        setError("Sessão expirada. Por favor, faça login novamente.");
      } else {
        setError(error.response?.data?.message || "Erro ao excluir empresa");
      }
    } finally {
      setLoading(false);
      fecharConfirmacaoExclusao();
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const imprimirEmpresa = (empresa) => {
    const novaJanela = window.open("", "_blank", "width=1000,height=800,scrollbars=yes");
    const isDarkMode = false; // Modo claro por padrão para impressão
    const usuarioLogado = JSON.parse(localStorage.getItem("usuario") || "{}");
    const dataHoraAtual = new Date().toLocaleString('pt-BR');
    const dataAtual = new Date().toLocaleDateString('pt-BR');

    if (!novaJanela) {
      alert("Não foi possível abrir a nova janela.");
      return;
    }

    const style = `
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 15px;
          background-color: ${isDarkMode ? '#121212' : '#ffffff'};
          color: ${isDarkMode ? '#ffffff' : '#000000'};
          line-height: 1.3;
          font-size: 11px;
        }
        h1 {
          text-align: center;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
          font-size: 18px;
          margin-bottom: 15px;
        }
        h2 {
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
          border-bottom: 1px solid ${isDarkMode ? '#424242' : '#e0e0e0'};
          padding-bottom: 5px;
          margin-top: 15px;
          font-size: 13px;
        }
        .header-info {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 7pt;
          color: #666;
          padding: 3px;
          background-color: white;
          border-bottom: 1px solid #eee;
        }
        .empresa-info {
          background-color: ${isDarkMode ? '#2a2a2a' : '#f5f5f5'};
          padding: 10px;
          border-radius: 5px;
          margin: 10px 0;
          font-size: 10px;
        }
        .empresa-info h3 {
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
          margin-bottom: 8px;
          font-size: 12px;
        }
        .info-row {
          display: flex;
          margin: 3px 0;
          border-bottom: 1px solid ${isDarkMode ? '#424242' : '#e0e0e0'};
          padding-bottom: 2px;
        }
        .info-label {
          font-weight: bold;
          width: 120px;
          color: ${isDarkMode ? '#90caf9' : '#1976d2'};
        }
        .info-value {
          flex: 1;
        }
        .assinatura-section {
          margin-top: 20px;
          text-align: center;
        }
        .linha-assinatura {
          width: 250px;
          border-bottom: 1px solid ${isDarkMode ? '#424242' : '#000'};
          margin: 10px auto;
          height: 1px;
        }
        .botoes {
          margin-top: 15px;
          text-align: center;
        }
        button {
          background-color: ${isDarkMode ? '#1976d2' : '#1976d2'};
          color: white;
          padding: 8px 15px;
          margin: 3px;
          border: none;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
          width: 150px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
        }
        button:hover {
          background-color: ${isDarkMode ? '#1565c0' : '#1565c0'};
        }
        .material-icons {
          color: white;
          font-size: 14px;
        }
        @media print {
          .header-info {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            text-align: center;
            font-size: 7pt;
            color: #666;
            padding: 3px;
            background-color: white;
            border-bottom: 1px solid #eee;
          }
          body {
            padding-top: 20px;
          }
          button {
            display: none;
          }
        }
      </style>
    `;

    let conteudo = `
      <html>
      <head>
        <title>Dados da Empresa - ${empresa.st_nome}</title>
        ${style}
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
      </head>
      <body>
        <div class="header-info">
          Impresso pelo usuário: ${usuarioLogado.nome || usuarioLogado.st_nome || 'Usuário não identificado'} - ${usuarioLogado.email || usuarioLogado.st_email || 'Email não identificado'} em ${dataHoraAtual}
        </div>

        <h1>DADOS DA EMPRESA</h1>

        <div class="empresa-info">
          <h3>Informações da Empresa:</h3>
          <div class="info-row">
            <div class="info-label">Nome/Razão Social:</div>
            <div class="info-value">${empresa.st_nome}</div>
          </div>
          <div class="info-row">
            <div class="info-label">Tipo de Pessoa:</div>
            <div class="info-value">${empresa.st_tipoPessoa === 'FISICA' ? 'Física' : 'Jurídica'}</div>
          </div>
          <div class="info-row">
            <div class="info-label">${empresa.st_tipoPessoa === 'FISICA' ? 'CPF:' : 'CNPJ:'}</div>
            <div class="info-value">${empresa.st_tipoPessoa === 'FISICA' ? formatarCPF(empresa.st_cpfCnpj) : formatarCNPJ(empresa.st_cpfCnpj)}</div>
          </div>
          <div class="info-row">
            <div class="info-label">Email:</div>
            <div class="info-value">${empresa.st_email || 'N/A'}</div>
          </div>
          <div class="info-row">
            <div class="info-label">Telefone:</div>
            <div class="info-value">${empresa.st_telefone || 'N/A'}</div>
          </div>
          <div class="info-row">
            <div class="info-label">Endereço:</div>
            <div class="info-value">${empresa.st_endereco || 'N/A'}</div>
          </div>
          <div class="info-row">
            <div class="info-label">Status:</div>
            <div class="info-value">${empresa.bo_ativo ? 'Ativo' : 'Inativo'}</div>
          </div>
          ${empresa.st_observacoes ? `
          <div class="info-row">
            <div class="info-label">Observações:</div>
            <div class="info-value">${empresa.st_observacoes}</div>
          </div>
          ` : ''}
        </div>

        <div class="assinatura-section">
          <p><strong>Local e Data:</strong> ${dataAtual}</p>
          <div class="linha-assinatura"></div>
          <p><strong>${empresa.st_nome}</strong></p>
          <p>${empresa.st_tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'}: ${empresa.st_tipoPessoa === 'FISICA' ? formatarCPF(empresa.st_cpfCnpj) : formatarCNPJ(empresa.st_cpfCnpj)}</p>
          <p style="font-size: 9px; margin-top: 10px; color: #666;">
            <strong>Observação:</strong> Este documento foi gerado automaticamente em ${dataHoraAtual} pelo usuário ${usuarioLogado.nome || usuarioLogado.st_nome || 'Sistema'}.
          </p>
        </div>

        <div class="botoes">
          <button onclick="window.print()">
            <span class="material-icons">print</span>
            Imprimir Documento
          </button>
          <button onclick="window.close()">
            <span class="material-icons">close</span>
            Fechar
          </button>
        </div>
      </body>
      </html>
    `;

    novaJanela.document.write(conteudo);
    novaJanela.document.close();
  };

  const formatarCNPJ = (cnpj) => {
    if (!cnpj) return "";
    const numeros = cnpj.replace(/\D/g, "");
    if (numeros.length <= 11) return numeros; // CPF (não mexe aqui)
    return numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  };

  const formatarCPF = (cpf) => {
    if (!cpf) return "";
    const numeros = cpf.replace(/\D/g, "");
    if (numeros.length <= 11) return numeros; // CPF (não mexe aqui)
    return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  };

  const empresasFiltradas = empresas
    .filter((empresa) => {
      return (
        empresa.st_nome.toLowerCase().includes(filtros.st_nome.toLowerCase()) &&
        empresa.st_email.toLowerCase().includes(filtros.st_email.toLowerCase()) &&
        empresa.st_cpfCnpj.toLowerCase().includes(filtros.st_cpfCnpj.toLowerCase())
      );
    })
    .sort((a, b) => {
      const isAsc = order === "asc";
      if (orderBy === "st_nome" || orderBy === "st_email") {
        return isAsc
          ? a[orderBy].localeCompare(b[orderBy])
          : b[orderBy].localeCompare(a[orderBy]);
      } else if (orderBy === "st_cpfCnpj") {
        const aValue = (a[orderBy] && a[orderBy].replace(/\D/g, "")) || "";
        const bValue = (b[orderBy] && b[orderBy].replace(/\D/g, "")) || "";
        return isAsc
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else if (orderBy === "bo_ativo") {
        return isAsc
          ? (a[orderBy] === b[orderBy] ? 0 : a[orderBy] ? -1 : 1)
          : (a[orderBy] === b[orderBy] ? 0 : a[orderBy] ? 1 : -1);
      }
      return 0;
    });

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros({ ...filtros, [name]: value });
    setPage(0);
  };

  // Verificar acesso do usuário
  if (!verificarAcessoUsuario("empresas")) {
    return <AcessoRestrito />;
  }

  return (
    <AcessoRestrito modulo="empresas">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Notificações */}
        <Snackbar 
          open={!!error} 
          autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>

        <Snackbar 
          open={!!success} 
          autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
          onClose={() => setSuccess(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
            {success}
          </Alert>
        </Snackbar>
        
        {/* Box interno com margens de 1,5% */}
        <Box sx={{
          margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>

          {/* Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: { xs: 2, sm: 3 },
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2
            }}
          >
            <Typography 
              variant="h5" 
              mb={1} 
              sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <BusinessIcon sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                color: '#FFC107' // Mesma cor usada no menu lateral
              }} />
              Empresas
            </Typography>
            <Button 
              variant="contained" 
              onClick={() => abrirFormulario()}
              sx={{
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: 'auto', sm: '200px' },
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark
                }
              }}
            >
              <AddIcon /> Nova Empresa
            </Button>
          </Box>

        {/* Container da Tabela */}
        <TableContainer 
          component={Paper} 
          sx={{ 
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'auto',
            height: {
              xs: 'calc(90vh - 140px)',  // Mobile: mais espaço para header
              sm: 'calc(90vh - 120px)',  // Tablet: espaço padrão
              md: 'calc(90vh - 120px)',  // Desktop: espaço padrão
              lg: 'calc(90vh - 120px)'   // Large: espaço padrão
            },
            maxHeight: {
              xs: 'calc(90vh - 140px)',
              sm: 'calc(90vh - 120px)',
              md: 'calc(90vh - 120px)',
              lg: 'calc(90vh - 120px)'
            },
            width: '100%', // ✅ 100% da largura da página
            minWidth: { xs: '100%', sm: '600px' }, // ✅ 100% do mínimo também
            maxWidth: '100%', // ✅ Limita a 100% máximo
            boxShadow: (theme) => theme.palette.mode === 'dark' 
              ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
              : '0 2px 8px rgba(0, 0, 0, 0.06)',
            borderRadius: 2,
            border: 'none'
          }}
        >
          <Table sx={{ minWidth: '100%', tableLayout: 'fixed' }}>
            <TableHead sx={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              backgroundColor: (theme) => theme.palette.background.paper,
              '& .MuiTableCell-root': {
                backgroundColor: 'inherit',
                borderBottom: '1px solid rgba(224, 224, 224, 1)'
              }
            }}>
              <TableRow>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  minWidth: { xs: '150px', sm: '120px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "st_nome"}
                    direction={orderBy === "st_nome" ? order : "asc"}
                    onClick={() => handleRequestSort("st_nome")}
                  >
                    Nome
                  </TableSortLabel>
                  <TextField
                    name="st_nome"
                    size="small"
                    fullWidth
                    value={filtros.st_nome}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por nome"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "st_email"}
                    direction={orderBy === "st_email" ? order : "asc"}
                    onClick={() => handleRequestSort("st_email")}
                  >
                    Email
                  </TableSortLabel>
                  <TextField
                    name="st_email"
                    size="small"
                    fullWidth
                    value={filtros.st_email}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por email"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '15%' },
                  minWidth: { xs: '100px', sm: '80px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "st_cpfCnpj"}
                    direction={orderBy === "st_cpfCnpj" ? order : "asc"}
                    onClick={() => handleRequestSort("st_cpfCnpj")}
                  >
                    CPF/CNPJ
                  </TableSortLabel>
                  <TextField
                    name="st_cpfCnpj"
                    size="small"
                    fullWidth
                    value={filtros.st_cpfCnpj}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por CPF/CNPJ"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '12%' },
                  minWidth: { xs: '80px', sm: '70px' },
                  textAlign: 'center'
                }}>
                  <TableSortLabel
                    active={orderBy === "bo_ativo"}
                    direction={orderBy === "bo_ativo" ? order : "asc"}
                    onClick={() => handleRequestSort("bo_ativo")}
                  >
                    Ativo
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '12%' },
                  minWidth: { xs: '100px', sm: '80px' },
                  textAlign: 'center'
                }}>
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : empresasFiltradas.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Nenhuma empresa encontrada.
                  </TableCell>
                </TableRow>
              ) : (
                empresasFiltradas
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((empresa, index) => (
                    <TableRow 
                      key={empresa.id || empresa.id_empresa || index}
                      sx={{
                        backgroundColor: (theme) => 
                          index % 2 === 0 
                            ? theme.palette.mode === 'dark' 
                              ? 'rgba(255, 255, 255, 0.02)' 
                              : 'rgba(0, 0, 0, 0.02)'
                            : 'transparent',
                        '&:hover': {
                          backgroundColor: (theme) => 
                            theme.palette.mode === 'dark' 
                              ? 'rgba(255, 255, 255, 0.08)' 
                              : 'rgba(0, 0, 0, 0.04)'
                        }
                      }}
                    >
                      <TableCell 
                        sx={{ 
                          overflow: 'hidden', 
                          textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap',
                          height: '40px', // ✅ Altura fixa para células
                          padding: '8px 16px', // ✅ Padding otimizado para 40px
                          verticalAlign: 'middle' // ✅ Alinhamento vertical centralizado
                        }}
                      >
                        {empresa.st_nome}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          overflow: 'hidden', 
                          textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap',
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle'
                        }}
                      >
                        {empresa.st_email}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          overflow: 'hidden', 
                          textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap',
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle'
                        }}
                      >
                        {empresa.st_tipoPessoa === TIPO_PESSOA_OPTIONS[0].value 
                          ? formatarCPF(empresa.st_cpfCnpj)
                          : formatarCNPJ(empresa.st_cpfCnpj)}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle',
                          textAlign: 'center'
                        }}
                      >
                                            {empresa.bo_ativo ? (
                      <Tooltip title={STATUS_OPTIONS[0].label}>
                        <ThumbUp className="material-icon-status-active" />
                      </Tooltip>
                    ) : (
                      <Tooltip title={STATUS_OPTIONS[1].label}>
                        <ThumbDown className="material-icon-status-inactive" />
                      </Tooltip>
                    )}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle',
                          textAlign: 'center'
                        }}
                      >
                        <Tooltip title="Visualizar">
                          <IconButton size="small" onClick={() => visualizarEmpresa(empresa)}>
                            <VisibilityIcon fontSize="small" className="material-icon-visibility" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                          <IconButton size="small" onClick={() => abrirFormulario(empresa)}>
                            <EditIcon fontSize="small" className="material-icon-edit" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excluir">
                          <IconButton size="small" onClick={() => confirmarExclusao(empresa)}>
                            <DeleteIcon fontSize="small" className="material-icon-delete" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          </TableContainer>
        </Box> {/* Fechamento do Box interno com margens */}
        
        {/* Paginação fora do Box interno */}
        <TablePagination
          component="div"
          count={empresasFiltradas.length}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage="Itens por página"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          sx={{
            backgroundColor: (theme) => theme.palette.background.default,
            borderTop: 'none',
            width: '100%',
            marginTop: 0
          }}
        />

      {/* Dialog de Cadastro/Edição */}
      <Dialog
        open={openForm}
        onClose={fecharFormulario}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            width: { xs: '95vw', sm: '90vw', md: '900px' },
            height: { xs: '95vh', sm: '90vh', md: '550px' },
            maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
            maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
            position: 'relative',
            margin: { xs: 'auto', sm: 'auto', md: 'auto' }
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          {empresaSelecionada ? "Editar Empresa" : "Nova Empresa"}
        </DialogTitle>
        <DialogContent sx={{ 
          height: { xs: 'calc(100% - 120px)', sm: 'calc(100% - 140px)' },
          overflow: 'auto',
          padding: { xs: 1, sm: 2 },
          '&.MuiDialogContent-root': {
            paddingTop: { xs: 1, sm: 2 }
          },
          position: 'relative',
          top: 0,
          marginBottom: { xs: '60px', sm: '60px' },
          '& .MuiInputLabel-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          },
          '& .MuiInputBase-input': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          },
          '& .MuiFormControlLabel-label': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          },
          '& .MuiTabs-root': {
            borderBottom: 1,
            borderColor: 'divider'
          },
          '& .MuiTab-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            textTransform: 'none',
            minWidth: { xs: 80, sm: 120 }
          }
        }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              mb: 2
            }}
          >
            <Tab label="Dados Básicos" />
            <Tab label="Contato" />
            <Tab label="Configurações" />
          </Tabs>

          {activeTab === 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField 
                  fullWidth 
                  label="Nome/Razão Social" 
                  name="st_nome" 
                  value={formData.st_nome} 
                  onChange={handleInputChange}
                  required
                  error={formErrors.st_nome}
                  helperText={formErrors.st_nome ? "Nome é obrigatório" : ""}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 200px' }}>
                  <FormControl fullWidth>
                    <InputLabel>Tipo de Pessoa</InputLabel>
                    <Select
                      name="st_tipoPessoa"
                      value={formData.st_tipoPessoa}
                      onChange={handleInputChange}
                      label="Tipo de Pessoa"
                      required
                    >
                      {TIPO_PESSOA_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label={formData.st_tipoPessoa === TIPO_PESSOA_OPTIONS[0].value ? "CPF" : "CNPJ"}
                    name="st_cpfCnpj"
                    value={formData.st_cpfCnpj}
                    onChange={handleInputChange}
                    required
                    error={formErrors.st_cpfCnpj}
                    helperText={formErrors.st_cpfCnpj ? "CPF/CNPJ é obrigatório" : ""}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField
                  fullWidth
                  label="Email"
                  name="st_email"
                  type="email"
                  value={formData.st_email}
                  onChange={handleInputChange}
                  required
                  error={formErrors.st_email}
                  helperText={formErrors.st_email ? "Email é obrigatório" : ""}
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Telefone"
                  name="st_telefone"
                  value={formData.st_telefone}
                  onChange={handleInputChange}
                  required
                  error={formErrors.st_telefone}
                  helperText={formErrors.st_telefone ? "Telefone é obrigatório" : ""}
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Endereço"
                  name="st_endereco"
                  value={formData.st_endereco}
                  onChange={handleInputChange}
                  multiline
                  rows={3}
                />
              </Box>
            </Box>
          )}

          {activeTab === 2 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField 
                  fullWidth 
                  label="Observações" 
                  name="st_observacoes" 
                  value={formData.st_observacoes} 
                  onChange={handleInputChange}
                  multiline 
                  rows={4}
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.bo_ativo}
                      onChange={handleInputChange}
                      name="bo_ativo"
                    />
                  }
                  label={STATUS_OPTIONS[0].label}
                />
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          },
          '& .MuiTypography-root': {
            fontSize: '0.875rem'
          }
        }}>
          <Typography variant="body2" color="text.secondary">
            {formatarDataHora(dataHoraAtual)}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => setActiveTab(prev => Math.max(0, prev - 1))}
              disabled={activeTab === 0}
            >
              Anterior
            </Button>
            <Button
              variant="outlined"
              onClick={() => setActiveTab(prev => Math.min(2, prev + 1))}
              disabled={activeTab === 2}
            >
              Próximo
            </Button>
            <Button
              variant="contained"
              onClick={fecharFormulario}
              sx={{
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              FECHAR
            </Button>
            <Button
              variant="contained"
              onClick={salvarEmpresa}
              disabled={loading}
              sx={{
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              {loading ? <CircularProgress size={24} /> : "SALVAR"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog de Visualização */}
      <Dialog
        open={openView}
        onClose={fecharVisualizacao}
        maxWidth="md"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: { xs: '95vw', sm: '90vw', md: '900px' },
            height: { xs: '95vh', sm: '90vh', md: '550px' },
            maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
            maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
            position: 'relative',
            margin: { xs: 'auto', sm: 'auto', md: 'auto' }
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Visualizar Empresa
          <IconButton
            onClick={fecharVisualizacao}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          '&.MuiDialogContent-root': {
            paddingTop: 2
          },
          position: 'relative',
          top: 0,
          marginBottom: '60px',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              mb: 2
            }}
          >
            <Tab label="Dados Básicos" />
            <Tab label="Contato" />
            <Tab label="Configurações" />
          </Tabs>

          {activeTab === 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField 
                  fullWidth 
                  label="Nome/Razão Social" 
                  value={empresaVisualizar?.st_nome || ""}
                  disabled
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label="Tipo de Pessoa"
                    value={empresaVisualizar?.st_tipoPessoa === "FISICA" ? "Física" : "Jurídica"}
                    disabled
                  />
                </Box>
                <Box sx={{ flex: '1 1 200px' }}>
                  <TextField
                    fullWidth
                    label={empresaVisualizar?.st_tipoPessoa === "FISICA" ? "CPF" : "CNPJ"}
                    value={empresaVisualizar?.st_tipoPessoa === "FISICA"
                      ? formatarCPF(empresaVisualizar?.st_cpfCnpj)
                      : formatarCNPJ(empresaVisualizar?.st_cpfCnpj)}
                    disabled
                  />
                </Box>
              </Box>
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField
                  fullWidth
                  label="Email"
                  value={empresaVisualizar?.st_email || ""}
                  disabled
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Telefone"
                  value={empresaVisualizar?.st_telefone || ""}
                  disabled
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Endereço"
                  value={empresaVisualizar?.st_endereco || ""}
                  disabled
                  multiline
                  rows={3}
                />
              </Box>
            </Box>
          )}

          {activeTab === 2 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <TextField 
                  fullWidth 
                  label="Observações" 
                  value={empresaVisualizar?.st_observacoes || ""}
                  disabled
                  multiline 
                  rows={4}
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={empresaVisualizar?.bo_ativo || false}
                      disabled
                    />
                  }
                  label={STATUS_OPTIONS[0].label}
                />
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: { xs: 1, sm: 2 },
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: { xs: '60px', sm: '60px' },
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 1, sm: 0 },
          '& .MuiButton-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            textTransform: 'uppercase',
            fontWeight: 500,
            minWidth: { xs: 'auto', sm: 'auto' }
          },
          '& .MuiTypography-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }
        }}>
          <Typography variant="body2" color="text.secondary">
            {formatarDataHora(dataHoraAtual)}
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 0.5, sm: 1 },
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            justifyContent: { xs: 'center', sm: 'flex-end' }
          }}>
            <Button
              variant="outlined"
              onClick={() => setActiveTab(prev => Math.max(0, prev - 1))}
              disabled={activeTab === 0}
              size={window.innerWidth < 600 ? "small" : "medium"}
            >
              Anterior
            </Button>
            <Button
              variant="outlined"
              onClick={() => setActiveTab(prev => Math.min(2, prev + 1))}
              disabled={activeTab === 2}
              size={window.innerWidth < 600 ? "small" : "medium"}
            >
              Próximo
            </Button>
            <Button
              variant="contained"
              onClick={fecharVisualizacao}
              size={window.innerWidth < 600 ? "small" : "medium"}
              sx={{
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              FECHAR
            </Button>
            <Button
              variant="contained"
              onClick={() => imprimirEmpresa(empresaVisualizar)}
              startIcon={<PrintIcon />}
              size={window.innerWidth < 600 ? "small" : "medium"}
              sx={{
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              IMPRIMIR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog de Confirmação de Exclusão */}
      <Dialog open={openDeleteConfirm} onClose={fecharConfirmacaoExclusao} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Confirmar Exclusão
        </DialogTitle>
        <DialogContent sx={{ padding: 2 }}>
          <Typography>
            Tem certeza que deseja excluir esta empresa?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          }
        }}>
          <Button onClick={fecharConfirmacaoExclusao}>CANCELAR</Button>
          <Button 
            variant="contained" 
            color="error" 
            onClick={deletarEmpresa} 
            disabled={loading}
          >
            EXCLUIR
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
    </AcessoRestrito>
  );
}
